import React, {useState} from 'react';
import PropTypes from 'prop-types';

import {IconoirTrash} from '@ey-xd/motif-icon';
import OutputText from '@ey/canvascoreservices/OutputText';

import Modal from '../../CoreWrappers/Modal';
import Button from '../../CoreWrappers/Button';
import LoadingWrapper from '../../CoreWrappers/LoadingWrapper';

const DeleteCommentModal = ({onSave, labels}) => {
	const [show, setShow] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const handleClose = () => setShow(false);

	const handleSubmit = () => {
		setIsLoading(true);

		onSave &&
			onSave()
				.then(() => {
					setIsLoading(false);
					setShow(false);
				})
				.finally(() => setIsLoading(false));
	};

	const renderTrigger = () => {
		const props = {
			svg: IconoirTrash,
			variant: 'ghost',
			title: labels.triggerText,
			onClick: () => {
				setShow(true);
			}
		};

		return <Button {...props} />;
	};

	const renderModal = () => {
		const props = {
			show,
			modalsize: 'x-small',
			title: labels.titleText,
			labels: {
				modalConfirmBtnLabel: labels.confirmLabel,
				modalCancelBtnLabel: labels.cancelLabel,
				modalCloseBtnTitletip: labels.closeLabel
			},
			onClose: handleClose,
			onOkClick: handleSubmit,
			isOkDisabled: isLoading,
			isCancelDisabled: isLoading,
			closeButtonProps: {
				disabled: isLoading
			},
			isLoading
		};

		return (
			show && (
				<Modal {...props}>
					<OutputText light>{labels.instructionalText}</OutputText>
				</Modal>
			)
		);
	};

	return (
		<>
			{renderTrigger()}
			{renderModal()}
		</>
	);
};

DeleteCommentModal.propTypes = {
	onSave: PropTypes.func.isRequired,
	labels: PropTypes.shape({
		triggerText: PropTypes.string,
		titleText: PropTypes.string,
		instructionalText: PropTypes.string,
		confirmLabel: PropTypes.string,
		cancelLabel: PropTypes.string,
		closeLabel: PropTypes.string
	})
};

export default DeleteCommentModal;
